import {SelectItem} from "@/store/types";

export interface TemplatesState {
  templates?: any
  allTemplates: TemplateItem[]
  multichannelTemplates?: any[]
  templateItem?: TemplateItem
}

export class TemplatesFilterParams {
  id?: number;
  is_active?: number | string;
  partner?: string;
  partner_user?: string;
  name?: string;
  status?: string;
  priority?: string;
  message?: string;
  content?: string;
  subject?: string;
  page_number: number = 1;
}

export interface TemplateItem {
  id?: number
  name: string,
  partner?: string,
  partner_id?: number | null,
  partner_user?: string,
  partner_user_id?: number | null,
  status?: string,
  channel?: string,
  priority: number,
  is_active?: number,
  originator?: string,
  originator_id?: null | number,
  blacklist_name?: string,
  blacklist_id?: number | null,
  delivery_type?: string | null,
  ttl?: number | null,
  start_datetime?: string | null,
  end_datetime?: string | null,
  start_time?: string | null,
  end_time?: string | null,
  multichannel_timeout?: number|null,
  multichannel_id?: number | null,
  multichannel_name?: string | null,
  multichannel?: string | null,
  multichannel_template_id?: number | null,
  multichannel_template_name?: string,
  multichannel_positive_sending?: number | null,
  message_type_id?: number | null,
  message_type_name?: string,
  starting_datetime?: string | null,
  ending_datetime?: string | null,
  send_evenly?: number,
  allowed_days?: string[],
  max_throughput?: number | null,
  save_text?: number | null,
  mn_service_id?: number | null,
  mn_template_id?: number | null,
  template_params?: TemplateParamValue[]
}

export interface SmsTemplateItem extends TemplateItem {
  message?: string,
  message_length?: number | null
}

export class TemplateItemImpl implements TemplateItem {
  constructor() {
    this.name = '',
    this.partner_id = null,
    this.partner_user_id = null,
    this.originator_id = null,
    this.starting_datetime = '',
    this.ending_datetime = '',
    this.priority = 2,
    this.ttl = null,
    this.blacklist_id = null,
    this.message_type_id = null,
    this.max_throughput = null,
    this.save_text = 1,
    this.multichannel_id = null,
    this.multichannel_name = null,
    this.multichannel_template_id = null,
    this.multichannel_timeout = 0,
    this.start_datetime = '',
    this.end_datetime = '',
    this.start_time = '',
    this.end_time = '',
    this.allowed_days = ['MON','TUE','WED','THU','FRI','SAT','SUN'],
    this.send_evenly = 0,
    this.is_active = 1,
    this.template_params = []
  }
  id?: number;
  name: string;
  partner?: string;
  partner_id?: number | null;
  partner_user?: string;
  partner_user_id?: number | null;
  status?: string;
  channel?: string;
  priority: number;
  is_active?: number;
  originator?: string;
  originator_id?: null | number;
  multichannel_name?: null | string;
  blacklist_name?: string;
  blacklist_id?: number | null;
  ttl?: number | null;
  start_datetime?: string | null;
  end_datetime?: string | null;
  start_time?: string | null;
  end_time?: string | null;
  multichannel_timeout?: number|null;
  multichannel_id?: number | null;
  multichannel?: string | null;
  multichannel_template_id?: number | null;
  multichannel_template_name?: string;
  message_type_id?: number | null;
  message_type_name?: string;
  starting_datetime?: string | null;
  ending_datetime?: string | null;
  send_evenly?: number;
  allowed_days?: string[];
  max_throughput?: number | null;
  save_text?: number | null;
  mn_service_id?: number | null;
  mn_template_id?: number | null;
  template_params?: TemplateParamValue[]
}

export class SmsTemplateItemImpl extends TemplateItemImpl {
  message?: string;
  message_length?: number | null

  constructor() {
    super();
    this.message = '';
    this.message_length = null;
  }
}
export class PushTemplateItemImpl extends TemplateItemImpl {
  message?: string;
  title?: string;
  content?: string;
  application_id?: number|null;
  multichannel_positive_sending?: number | null;
  app_groups?: { id: number; name: string }[];
  app_groups_ids?: number[];
  applications?: { id: number; name: string }[];
  applications_ids?: number[];
  app_by_date?: number | null;
  sub_by_date: number | null;
  group_selection_rule?: number | null;
  app_selection_rule?: number | null;

  constructor() {
    super();
    this.message = '';
    this.title = '';
    this.content = '';
    this.app_by_date = 1;
    this.sub_by_date = 1;
    this.group_selection_rule = 1;
    this.app_selection_rule = 1;
    this.application_id = null;
    this.multichannel_positive_sending = 0;
    this.applications_ids = [];
    this.app_groups_ids = [];
  }
}

export interface EmailFileItem {
  id?: number,
  name: string,
  base64: string
}
export class EmailTemplateItemImpl extends TemplateItemImpl {
  message?: string;
  subject?: string;
  address_from?: string;
  attached_files?: EmailFileItem[];

  constructor() {
    super();
    this.message = '';
    this.subject = '';
    this.address_from = '';
    this.attached_files = [];
  }
}

export interface TemplateParamValue {
  template_params_list_id: number | null;
  value: string;
}

